import { render, staticRenderFns } from "./HeaderTopIcons.vue?vue&type=template&id=0d9fabb1&scoped=true&"
import script from "./HeaderTopIcons.vue?vue&type=script&lang=js&"
export * from "./HeaderTopIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9fabb1",
  null
  
)

export default component.exports